import * as _ from "lodash";

export class Effort {
    public id: string | null = null;
    public name: string | null = null;
    public status = "Active";
    public description: string | null = null;
    public icon: string | null = null;
    public creator: any = null;
    public lastupdater: any = null;
    public selectedUsers: any;

    public type?: string;
    public canvasser?: any;
    public checked?: any;

    constructor(effortData?: any) {
        if (effortData && effortData.attributes) {
            this.setData(effortData.attributes);
            this.id = effortData.id;
        } else if (effortData) {
            this.setData(effortData);
        }
    }

    setData(data: object): void {
        _.merge(this, data);
    }
}
